import { useEffect } from 'react';
import styles from './index.module.sass';
import { CHANGE_CURRENT_PAGE, PAGE_LICENSE_PLATES, useAppContext } from 'use-app';
import analytics from 'service/analytics';
import { DownloadLicensePlateButton } from './download-license-plate-button';
import { LicensePlatesContent } from './license-plates-content';

const LicensePlates = () => {
  const { dispatch: appDispatch } = useAppContext();

  useEffect(() => {
    analytics.licensePlatesPageView();
  }, []);

  useEffect(() => {
    appDispatch({
      type: CHANGE_CURRENT_PAGE,
      payload: PAGE_LICENSE_PLATES,
    });
  }, [appDispatch]);

  return (
    <div className={styles.main}>
      <div className={styles.title} style={{ marginBottom: 20 }}>
        <p>付款車牌</p>
        <DownloadLicensePlateButton />
      </div>
      <LicensePlatesContent />
    </div>
  );
};

export default LicensePlates;
